import { Component, OnInit } from '@angular/core'
import releases from '../release_logs.json'
import { AuthProvider } from './providers/auth.provider'

import { MenuController, ModalController } from '@ionic/angular'
import { PrimeNGConfig } from 'primeng/api'
import { DeviceController } from './controllers/device.controller'
import { GlobalController } from './controllers/global.controller'

import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs/operators'
import { MESSAGE_TYPES } from 'src/app/utils/constants.utils'
import { ChangelogComponent } from './components/changelog/changelog.component'
import { LogoutService } from './services/logout.service'
import { NotificationsService } from './services/notifications.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public appPages = []
  public dashboards = []
  showSideMenu = false
  userRole = 'employee'
  releases = []
  sideMenuEnabled = false

  constructor(
    private router: Router,
    public authProvider: AuthProvider,
    private deviceCtrl: DeviceController,
    public globalCtrl: GlobalController,
    public logoutService: LogoutService,
    private modalCtrl: ModalController,
    private PrimeNGConfig: PrimeNGConfig,
    public notificationsService: NotificationsService,
    private menuController: MenuController
  ) {
    this.globalCtrl.events.subscribe('user:login', () => {
      this.showSideMenu = true
      this.sideMenuEnabled = true
      this.userRole = this.authProvider.getUserRole()
      return false
    })
    this.globalCtrl.events.subscribe('user:logout', () => {
      this.showSideMenu = false
      this.sideMenuEnabled = false
    })
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      if (this.authProvider.getUserRole() === 'admin') {
        this.notificationsService.updateMessageAlerts()
        this.notificationsService.updateHourAlerts()
        this.notificationsService.updateAlerts(7)
      }
    })
  }

  ngOnInit() {
    this.releases = releases

    this.appPages = [
      {
        title: 'Overview',
        url: '/overview',
        icon: 'podium',
        data_cy: 'overviewPage',
      },
      {
        title: 'Assignations',
        url: '/matching',
        icon: 'link',
        data_cy: 'matchingPage',
      },
      {
        title: 'Commandes',
        url: '/orders',
        icon: 'file-tray-full',
        data_cy: 'orderPage',
      },
      {
        title: 'Clients',
        url: '/clients',
        icon: 'happy',
        data_cy: 'clientsPage',
      },
      {
        title: 'Superviseurs',
        url: '/supervisor',
        icon: 'megaphone',
        data_cy: 'supervisorPage',
      },
      {
        title: 'Employés',
        url: '/employees',
        icon: 'people',
        data_cy: 'employeesPage',
      },
      {
        title: 'Sugar Babies',
        url: '/applicants',
        icon: 'people-circle',
        data_cy: 'applicantsPage',
      },
      {
        parent: {
          title: 'Communications',
          url: '/messages',
          icon: 'mail',
          data_cy: 'messagesPage',
          alerts: true,
        },
        children: [
          { title: 'Général', url: '/messages/general', alerts: true, messageType: MESSAGE_TYPES.GENERAL },
          {
            title: 'Assignation',
            url: '/messages/assignation',
            alerts: true,
            messageType: MESSAGE_TYPES.ASSIGNATION,
          },
          {
            title: 'Sugar Babies',
            url: '/messages/applicants',
            alerts: true,
            messageType: MESSAGE_TYPES.APPLICANTS,
          },
        ],
      },
      {
        title: 'Feuilles de temps',
        url: '/timesheets',
        icon: 'time',
        data_cy: 'timesheetPage',
      },
      { title: 'Outils', url: '/tools', icon: 'hammer', data_cy: 'ToolsPage' },
      {
        title: 'Compétences',
        url: '/skills',
        icon: 'school',
        data_cy: 'skillsPage',
      },
    ]

    this.dashboards = [
      {
        title: 'Employés dispo.',
        url: '/dashboard-employees',
        icon: 'people',
      },
      { title: 'Clients Actuels', url: '/clients-dashboard', icon: 'happy' },
      { title: 'Localisations', url: '/dashboard/map', icon: 'map' },
      { title: 'Absences', url: '/absences', icon: 'calendar' },
      {
        title: 'Alertes',
        url: '/alerts',
        icon: 'alert-circle',
        alerts: true,
        messageType: MESSAGE_TYPES.SITES_ALERTS,
      },
      {
        title: 'Alertes Heures',
        url: '/hour-alerts',
        icon: 'time',
        alerts: true,
        messageType: MESSAGE_TYPES.HOUR_ALERTS,
      },
    ]

    // no need to configure luxon day of the week start, it is already set to monday

    this.PrimeNGConfig.setTranslation({
      dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      monthNames: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ],
      dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
      startsWith: 'Commence par',
      contains: 'Contient',
      notContains: 'Ne contient pas',
      endsWith: 'Se termine par',
      equals: 'Égal à',
      notEquals: 'Différent de',
      noFilter: 'Pas de filtre',
      lt: 'Inférieur à',
      lte: 'Inférieur ou égal à',
      gt: 'Supérieur à',
      gte: 'Supérieur ou égal à',
      is: 'Est',
      isNot: "N'est pas",
      before: 'Avant',
      after: 'Après',
      clear: 'Effacer',
      apply: 'Appliquer',
      matchAll: 'Correspond à tout',
      matchAny: 'Correspond à un',
      addRule: 'Ajouter une règle',
      removeRule: 'Supprimer',
      accept: 'Oui',
      reject: 'Non',
      choose: 'Choisir',
      upload: 'Téléverser',
      cancel: 'Annuler',
      dateAfter: 'Date après',
      dateBefore: 'Date avant',
      dateIs: 'Date est',
      dateIsNot: "Date n'est pas",
    })

    this.showSideMenu = true
  }

  showSplitPane() {
    if (this.authProvider.getUserRole() !== 'admin') {
      this.sideMenuEnabled = false
      return false
    }
    this.sideMenuEnabled = true

    return this.deviceCtrl.desktopView && this.showSideMenu
  }

  async openChangesModal() {
    const showReleaseModal = await this.modalCtrl.create({
      component: ChangelogComponent,
      cssClass: 'desktopReleaseLogsModal',
      componentProps: {
        releases: this.releases,
      },
    })

    await showReleaseModal.present()
  }

  accordionClicked(event: Event) {
    event.stopPropagation()
  }

  async childItemClicked(event: Event) {
    await this.menuController.close()
  }
}
